const formBase = {
  focusTo (el) {
    this.$refs[el].focus()
  },
  _formatearRut (val) {
    this.rut = this.cleanSpecialChars(val, 'rut')
    this.rut = this.formatearRut(this.rut)
  },

  keyPressCheckSpecialChars (evt, type) {
    evt = (evt) || window.event
    const strCompare = evt.key
    if (strCompare !== this.cleanSpecialChars(strCompare, type)) {
      evt.preventDefault()
    } else {
      return true
    }
  },

  cleanSpecialChars (val, type) {
    if (!val) return val
    if (type === 'name') return val.replace(/[^A-Za-zÀ-ÿ ]+$/g, '')
    if (type === 'paises') return val.replace(/[^a-zA-ZÀ-ÿ.,; ]/g, '')
    if (type === 'email') return val.replace(/[^a-zA-Z0-9\-_@.]/g, '')
    if (type === 'phone') return val.replace(/[^0-9]/g, '')
    if (type === 'rut') return val.replace(/[^0-9-Kk.]/g, '').replace(/\//, '').replace(/:/, '')
    if (type === 'comment') return val.replace(/[^a-zA-Z0-9À-ÿ. ;,¿?¡!$%]/g, '')
    if (type === 'numbers') return val.replace(/[^0-9]/g, '')
    if (type === 'orderNumber') return val.replace(/[^a-zA-ZÀ-ÿ0-9-]/g, '')

    return val.replace(/[^a-zA-ZÀ-ÿ0-9;,.: ]/g, '')
  },

  formatearRut (rut) {
    if (!rut) return rut
    let rutPuntos = ''
    const actual = rut.replace(/^0+/, '').replace(/ /, '')
    if (actual !== '' && actual.length > 1) {
      const sinPuntos = actual.replace(/\./g, '')
      const actualLimpio = sinPuntos.replace(/-/g, '')
      const inicio = actualLimpio.substring(0, actualLimpio.length - 1)
      let i = 0
      let j = 1
      for (i = inicio.length - 1; i >= 0; i--) {
        const letra = inicio.charAt(i)
        rutPuntos = letra + rutPuntos
        if (j % 3 === 0 && j <= inicio.length - 1) {
          rutPuntos = '.' + rutPuntos
        }
        j++
      }
      const dv = actualLimpio.substring(actualLimpio.length - 1)
      rutPuntos = rutPuntos + '-' + dv
    }
    return rutPuntos.toUpperCase()
  },
  _clearError () {
    this.errormsg = ''
  },
  validatePhoneFormat (phone) {
    try {
      const regex = /^[1-9]{1}[0-9]{8,13}$/
      if (regex.test(phone)) return true
      return false
    } catch (error) {
      return false
    }
  }
}
export default {
  formBase
}
